
import * as storyblokRuntime$EbmeTzG9SDqMPwLWdaMTjT0Fv_45SzUcT9xfySaJ0mO8A from '/src/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$P2QNrDfdvVhWjcrM_YBScDZ6nR8eFPiuJIfQeapJNIM from '/src/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$EbmeTzG9SDqMPwLWdaMTjT0Fv_45SzUcT9xfySaJ0mO8A, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$P2QNrDfdvVhWjcrM_YBScDZ6nR8eFPiuJIfQeapJNIM, defaults: {} }
}
        